import React from 'react';
import I from './styles';

const Icon = ({ children }) => {
	return (
		<I>
			{children}
		</I>
	);
};

export default Icon;